module.exports = __webpack_public_path__ + "static/media/zen.27b45756.png";